

export const teacherSlugToName: Record<string, string> = {
  'ilich': 'Ильич',
  'matemanya': 'МатемАня',
  'tanya-shibitova': 'Таня Шибитова',
  'valentinych': 'Валентиныч',
  'nastya-korzheva': 'Настя Коржева',
  'masha-korshunova': 'Маша Коршунова',
  'masha-ptipca': 'Маша Птипца',
  'artem-imaev': 'Артём Имаев',
  'sanya-ehbonit': 'Саня Эбонит',
  'top-repetitor': 'Топ-репетитор',
  'kseniya-napolskaya': 'Ксения Напольская',
  'mark-lamark': 'Марк Ламарк',
  'katya-stroganova': 'Катя Строганова',
  'olya-stepanova': 'Оля Степанова',
  'polina-belova': 'Полина Белова',
  'dyadya-artem': 'Дядя Артём',
  'azat-adeev': 'Азат Адеев',
  'vadim-edemskiy': 'Вадим Едемский',
  'fedos-kokos': 'Федос Кокос',
  'alena-turenko': 'Алёна Туренко',
  'ilya-sagalov': 'Илья Сагалов',
  'daniil-vasilev': 'Даниил Васильев',
  'marina-medvedeva': 'Марина Медведева',
  'sasha-teplaya': 'Саша Тёплая',
  'new-teacher': 'Новый преподаватель',
  'danya-vasilev': 'Даня Васильев',
  'kostya-makienko': 'Костя Макиенко',
}; 